// extracted by mini-css-extract-plugin
export var landing = "about-module--landing--X-5dC";
export var container = "about-module--container--3dvfR";
export var teamContainer = "about-module--team-container--BeETv";
export var teamWrapper = "about-module--team-wrapper--16hym";
export var teamGrid = "about-module--team-grid--21hzQ";
export var person = "about-module--person--2zbBh";